import React, { useCallback } from 'react'

import Select from '@/components/UI/Select'

import { InputSelect } from '../styled'
import { FormContext, type FormInputType, type Option } from '../types'

const FormInputMultiSelect: React.FC<{
  input: FormInputType & { type: 'multi-select' }
}> = ({ input }) => {
  const { name: inputName } = input
  const { submitting, onChange } = React.useContext(FormContext)

  const defaultValue = React.useMemo(
    () => input.options.filter(option => input.initialValue?.includes(option.value)),
    [input]
  )

  const handleChange = useCallback(
    (options: readonly Option[] | null | undefined) => {
      onChange(inputName, options?.map(option => option.value) || [])
    },
    [onChange, inputName]
  )

  return (
    <InputSelect>
      <Select
        instanceId={input.name}
        name={input.name}
        options={input.options}
        defaultValue={defaultValue}
        onChange={handleChange}
        isDisabled={submitting || input.disabled}
        isSearchable
        isMulti
        isClearable
        closeMenuOnSelect={false}
        styles={{
          control: base => ({
            ...base,
            borderColor: 'border',
          }),
        }}
      />
    </InputSelect>
  )
}

export default FormInputMultiSelect
